import React, { useState, useEffect } from "react";
import axios from "axios";
import { getToken, getUser } from "../../Utils/Common";
import { useNavigate, Link } from "react-router-dom";
import { ResponseMessage } from "../../components/messages/response-message";

function Showoffer(props) {
  const [status, setStatus] = useState("");
  const [subscription, setSubscription] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const user = getUser();
  const token = getToken();
  const [errorMessage, setErrorMessage] = useState("");
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  // const dispatch = useDispatch();

  const makeTran = () => {
    console.log("click me");
    const user = getUser();
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/create-discount`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        price: "price_1LA3fiHuNOGPY9ja0CX9qXiI",
        // user_id: user.id,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          setStatus(200);
          setMessage(response.data.message);
          window.location.replace(response.data.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
          setMessage(error.response.data.message);
        } else if (error.response.status === 401) {
          console.log(error.response);
          setStatus(401);
          setMessage(error.response.data.message);
        } else if (error.response.status === 422) {
          console.log(error.response.data.message);
          setStatus(422);
          setMessage(error.response.data.message);
        } else {
        }
      });
  };

  return (
    <div className="container">
      <div className="card mb-5 mb-xl-8" style={{ marginTop: "140px" }}>
        <div className="fs-2hx mt-5 text-center">One last Offer </div>
        <div className="row">
          <div className="col-6 text-center border-active-light">
            <div className="row">
              <div className="col-12 mt-5 bg-gray-400 p-5">
                <h1>The most popular offer</h1>
              </div>
              <div className="col-12 p-19">
                {" "}
                <h1>Pay less, enjoy more</h1>
              </div>
              <div className="col-12 mt-10 mb-10 p-19">
                <h3>
                  Stay with us and get a 50% discount for one credit :
                  4,99$/month and then 9,99$/month
                </h3>
              </div>
              <div className="col-12">
                {/* <Link className="btn btn-dark" to={`/user/welcome`}>
                  Save 50 %
                </Link> */}

                <button onClick={makeTran} className="btn btn-dark">
                  Save 50 %
                </button>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="col-6 text-center border-active-light">
              <div className="row">
                <div className="col-12 mt-5">
                  {/* <h1>The most popular offer</h1> */}
                </div>
                <div className="col-12 p-19">
                  {" "}
                  <h1>Customer Service</h1>
                </div>
                <div className="col-12 mt-10 mb-10 p-19">
                  <h3>contact us</h3>
                </div>
                <div className="col-12">
                  <Link className="btn btn-dark" to={`/contact`}>
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-8 mb-5">
            <div className="col-3"></div>
            <div className="col-6 text-center">
              <Link
                className="btn btn-dark fs-1"
                to={`/account/cancellation/reason`}
              >
                Continue Cancellation
              </Link>
            </div>
            <div className="col-3"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Showoffer;
